import BaseEnum from './BaseEnum';

export default class PaymentMethod extends BaseEnum{
    static PAYPAL = 'PAYPAL';
    static STRIPE = 'STRIPE';
}
